/* eslint-disable import/no-anonymous-default-export */
export default (benefits = [], action) => {
    switch (action.type) {
        case 'DELETE_BENEFIT':
            return benefits.filter((benefit) => benefit._id !== action.payload );
        case 'FETCH_ALL_BENEFIT':
            return action.payload;
        case 'CREATE_BENEFIT':
            return [...benefits, action.payload];
        default:
            return benefits;
    }
}